import { ApiError, useGetOwnerHome } from '@myrentalmate/api-client';

import { okData } from '../../lib/apiData';

/** The owner's home data. A 403 means this login isn't linked to an owner record yet. */
export function useOwnerHome() {
  const query = useGetOwnerHome({ query: { retry: false } });
  return {
    home: okData(query.data),
    notLinked: query.error instanceof ApiError && query.error.status === 403,
    isError: query.isError,
  };
}
